import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  static targets = ['queryField']
  static values = { singleSelection: String }

  disableField() {
    if (this.singleSelectionValue === 'true') {
      this.queryFieldTarget.disabled = true
    }
  }

  enableField() {
    if (this.singleSelectionValue === 'true') {
      this.queryFieldTarget.disabled = false
    }
  }
}
